import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/edit.svg'
import _imports_2 from '@/assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d6858f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col lg:flex-row items-center mb-8 pt-4 justify-between lg:space-x-3 space-y-4 lg:space-y-0" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = { class: "flex flex-row items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add hiring fee")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "uppercase" }
const _hoisted_7 = { class: "uppercase" }
const _hoisted_8 = { class: "flex flex-row justify-start capitalize" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit fee")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Delete fee")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ModalHiringFee = _resolveComponent("ModalHiringFee")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
            class: "bg-white",
            placeholder: "Search for a hiring fee...",
            onOnSubmit: _ctx.getHiringFees
          }, null, 8, ["modelValue", "onOnSubmit"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.openModal = !_ctx.openModal;
            _ctx.hiringFee = [];
          })
          }, _hoisted_5)
        ])
      ]),
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-slot-mode": true,
        "is-hide-paging": true
      }, {
        company: _withCtx((data) => [
          _createElementVNode("div", null, _toDisplayString(data.value.company.name), 1)
        ]),
        name: _withCtx((data) => [
          _createElementVNode("div", null, _toDisplayString(data.value.first_name) + " " + _toDisplayString(data.value.last_name), 1)
        ]),
        title: _withCtx((data) => [
          _createElementVNode("div", null, _toDisplayString(data.value.title), 1)
        ]),
        original_amount: _withCtx((data) => [
          _createElementVNode("div", _hoisted_6, " $" + _toDisplayString((data.value.original_amount / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })) + " " + _toDisplayString(data.value.currency), 1)
        ]),
        amount: _withCtx((data) => [
          _createElementVNode("div", _hoisted_7, " $" + _toDisplayString((data.value.amount / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })) + " " + _toDisplayString(data.value.company.currency), 1)
        ]),
        status: _withCtx((data) => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(data.value.status), 1)
          ])
        ]),
        menu: _withCtx((data) => [
          (data.value.status === 'created')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "px-2",
                onClick: ($event: any) => (_ctx.openDropDown(data.value))
              }, _hoisted_11, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (data.value.id === _ctx.currentDropdown)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {
              _ctx.openModal = !_ctx.openModal;
              _ctx.closeMenu();
            }, ["stop"]))
                }, _hoisted_14),
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: ($event: any) => (_ctx.deleteExpense(data.value.id))
                }, _hoisted_17, 8, _hoisted_15)
              ])), [
                [_directive_click_away, _ctx.closeMenu]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable"]),
      _createVNode(_component_Paginator, {
        modelValue: _ctx.page,
        page: _ctx.page,
        pages: _ctx.pagination.total_pages,
        "range-size": 1,
        "onUpdate:modelValue": _ctx.updateHandler,
        total: _ctx.pagination.total_count,
        from: _ctx.pagination.from,
        to: _ctx.pagination.to
      }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
    ]),
    (_ctx.openModal)
      ? (_openBlock(), _createBlock(_component_ModalHiringFee, {
          key: 0,
          openModal: _ctx.openModal,
          "onUpdate:openModal": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openModal) = $event)),
          hiringFee: _ctx.hiringFee
        }, null, 8, ["openModal", "hiringFee"]))
      : _createCommentVNode("", true)
  ], 64))
}